<template>
    <div class="full-container g-bg" v-lazy:background-image="'//doc.yctop.com/yc/static/2020-9-16/bg.jpg'">
        <div class="login">
            <div class="login-cont">
                <div class="img-box">
                    <router-link to="/">
                        <img src="//doc.yctop.com/yc/static/2020-9-10/intrude-logo.png" alt="" class="yc-logo">
                    </router-link>
                </div>
                <div>
                    <p class="reg-row">{{$t("user.email")}}</p>
                    <el-input v-model="email"></el-input>
                </div>
                <div class="reg-err">
                    <span v-if="!!emailError">{{emailError}}</span>
                </div>
                <div>
                    <p class="reg-row">{{$t("user.pw")}}</p>
                    <el-input v-model="password" type="password"></el-input>
                </div>
                <div class="reg-err">
                    <span v-if="!!passwordError">{{passwordError}}</span>
                </div>
                <el-button type="primary" class="login-btn" @click="signIn" :loading="loading">{{$t("header.menu.login")}}</el-button>
                <div class="login-tips">
                    {{$t("user.new")}}
                    <router-link to="/user/register">{{$t("header.menu.register")}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
		return {
			email:'',
			password:'',
			emailError:'',
            passwordError:'',
            loading:false,
		}
	},
	methods:{
		signIn: function(){
			if(!this.verifyEmail()){
                return;
			}
			if(!this.verifyPW()){
                return;
            }
            this.loading=true
			let data = {
                email: this.email,
                pw: this.password, 
            }, successFn = function() {
                _this.loading=false
                _this.$router.push('/');
            }, failFn = function(msg) {
                _this.loading=false
                _this.passwordError = msg.message
            }, _this = this
            _this.$store.dispatch('signIn', data).then(successFn, failFn)
		},
		verifyEmail: function() {
			let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			if(this.email==''){
				this.emailError = 'Email Required'
				return false;
			}else if(!reg.test(this.email)){
				this.emailError = 'Email is invalid';
				return false;
			}
			this.emailError = ''
			return true;
		},
		verifyPW: function() {
			if(this.password==''){
				this.passwordError = 'Password Required'
				return false;
			}
			this.passwordError = ''
			return true;
		},
	}
}
</script>

<style scoped>
@import "~@/assets/css/view/user/signup.css";
</style>